import React from 'react'
import { useTranslation } from 'react-i18next'
import './DemoAccountIndicator.css'

type Props = {
  isDemo: boolean
  accountActive: boolean
}

function DemoAccountIndicator(props: Props) {
  const { t } = useTranslation(['accounts'])
  const { isDemo, accountActive } = props
  const indicatorText = accountActive ? t('demoAccount') : t('expiredDemoAccount')

  if (isDemo) {
    return (
      <div className="demo-tag"><i className="fas fa-tag demo-icon"></i>{indicatorText}</div>
    )
  } else {
    return null
  }
}

export default DemoAccountIndicator
